import { defaultHoverTransition } from '@shared/utils';
import cx from 'classnames';

import { ReactComponent as ChevronRight } from 'assets/icons/ChevronRight.svg';
import { IconType } from 'utils/types';

const iconVariants = {
  complementary: { wrapper: 'bg-complementary-50', icon: 'stroke-white' },
  noRoomSelected: { wrapper: 'bg-semantic-noRoomSelectedActionIconBg', icon: 'stroke-white' },
  gray: { wrapper: 'bg-gray-30', icon: 'stroke-gray-80' },
  primary: { wrapper: 'bg-primary-50', icon: 'stroke-white' },
  grayBlack: { wrapper: 'bg-gray-30', icon: 'stroke-black' },
} as const;

type SelectionButtonWithIconProps = {
  title: string;
  icon: IconType;
  iconVariant: keyof typeof iconVariants;
  onClick: () => void;
};

const SelectionButtonWithIcon = ({ title, icon: Icon, iconVariant, onClick }: SelectionButtonWithIconProps) => {
  const { wrapper, icon } = iconVariants[iconVariant];

  return (
    <button
      type="button"
      className={cx(
        'flex w-full items-center justify-between gap-6 rounded-2xl border border-gray-30 bg-white p-4 outline-none hover:bg-gray-10',
        defaultHoverTransition
      )}
      onClick={onClick}
    >
      <div className="flex min-w-0 flex-1 items-center gap-4">
        <div className={cx('flex h-10 w-10 shrink-0 items-center justify-center rounded-xl', wrapper)}>
          <Icon className={cx('h-6 w-6 shrink-0 stroke-1.5', icon)} />
        </div>
        <span className="font-medium text-black text-left md:truncate">{title}</span>
      </div>
      <ChevronRight className="h-6 w-6 shrink-0 stroke-1.5 stroke-gray-60" />
    </button>
  );
};

export default SelectionButtonWithIcon;
